import React from 'react';
import { Box } from '@mui/material';

const DividerBlock = ({ data, isSelected, onUpdate, previewMode, blockId, onSelectBlock }) => {
  const {
    height = 1,
    color = '#dddddd',
    backgroundColor = 'transparent',
    style = 'solid',
    width = '100%',
    marginTop = 20,
    marginBottom = 20,
    padding = 0,
    borderRadius = 0,
    opacity = 1,
    alignment = 'center',
  } = data;

  const containerStyles = {
    textAlign: alignment,
    marginTop: `${marginTop}px`,
    marginBottom: `${marginBottom}px`,
    padding: `${padding}px`,
    border: isSelected ? '1px dashed #007bff' : 'none',
    borderRadius: isSelected ? '4px' : 0,
    backgroundColor,
  };

  // Функция для создания правильного элемента разделителя в зависимости от стиля
  const getDividerElement = () => {
    const commonStyles = {
      width,
      margin: alignment === 'center' ? '0 auto' : 
             alignment === 'right' ? '0 0 0 auto' : '0',
      opacity,
    };

    switch (style) {
      case 'dashed':
        return (
          <Box
            sx={{
              ...commonStyles,
              height: `${height}px`,
              borderTop: `${height}px dashed ${color}`,
            }}
          />
        );
      case 'dotted':
        return (
          <Box
            sx={{
              ...commonStyles,
              height: `${height}px`,
              borderTop: `${height}px dotted ${color}`,
            }}
          />
        );
      case 'double':
        return (
          <Box
            sx={{
              ...commonStyles,
              height: `${Math.max(height, 3)}px`,
              borderTop: `1px solid ${color}`,
              borderBottom: `1px solid ${color}`,
              backgroundColor: 'transparent',
            }}
          />
        );
      default: // solid
        return (
          <Box
            sx={{
              ...commonStyles,
              height: `${height}px`,
              backgroundColor: color,
              borderRadius: `${borderRadius}px`,
            }}
          />
        );
    }
  };

  return (
    <Box sx={containerStyles}>
      {getDividerElement()}
    </Box>
  );
};

export default DividerBlock; 